import { NavigationItem } from '../navigation.interfaces';
import { Column, Filter } from '@nirvana/shared/dtos/types/shared/filters';
import { Category, ThreatType } from '@nirvana/shared/dtos/types/shared/threats';
import { TimeRangeKind } from '@nirvana/shared/dtos/types/shared/time';
import { Target } from '@nirvana/shared/dtos/types/dashboards/common';

export class CommonThreatsNavigationHelper {
  public static buildNavigationItem(
    elements: Array<HTMLElement>,
    filters: Array<Filter>,
    displayedColumns: Array<Column>
  ): NavigationItem {
    return {
      elements: elements,
      params: {
        displayedColumns: displayedColumns,
        filters: filters,
      },
    };
  }

  public static getLastDetectedOnFilterFromTimeRange(timeRange: number): Filter {
    return {
      lastDetectedOn: {
        timeRange: {
          kind: TimeRangeKind.RELATIVE_TIME_RANGE,
          relative: {
            lastNumDays: timeRange,
          },
        },
      },
    };
  }

  public static getCategoryFilter(): Filter {
    return {
      category: {
        in: [
          Category.FILE,
          Category.APPLICATION,
          Category.DEVICE,
          Category.EMAIL,
          Category.PROCESS,
          Category.WEBSITE,
          Category.CONNECTION,
          Category.AMSI_OBJECTS,
          Category.UEFI_OBJECTS,
        ],
      },
    };
  }

  public static getDeviceNameFilter(): Filter {
    return {
      deviceName: {
        contains: '',
      },
    };
  }

  public static getThreatTypeFilter(threatTypes: Array<ThreatType>): Filter {
    return {
      threatType: {
        in: threatTypes,
      },
    };
  }

  public static getCompanyFilter(targets: Array<Target>): Filter {
    const companyIds = targets.map(target => target.companyId);
    return {
      company: {
        in: companyIds,
      },
    };
  }
}
